import PrintToKhaiButton from "./PrintToKhaiButton";

export default PrintToKhaiButton